/* globals _, moment */

import Model from './base';

import getPlace from '../../service/placeid';

const { extend } = _;

export default Model.extend( {
	key: 'location',

	defaults: {
		id: '',
		name: '',
		address: '',
		lat: 0.0,
		lng: 0.0,
		distance: 0,
	},

	preinitialize: function( attributes = {} ) {
		if ( attributes.coords ) {
			extend( attributes, attributes.coords );
		}

		Model.prototype.preinitialize.apply( this, arguments );
	},

	initialize: function() {
		this.on( 'change:id', this.geocode );
		if ( this.id && ! ( this.get( 'lat' ) && this.get( 'lng' ) ) ) {
			this.geocode();
		}
	},

	getPosition: function( asString ) {
		var lat = this.get( 'lat' ),
			lng = this.get( 'lng' );

		return asString ? [ lat, lng ].join( ',' ) : { lat, lng };
	},

	hasPosition: function() {
		return this.get( 'lat' ) && this.get( 'lng' );
	},

	bindAddress: function() {
		return [
			'change:address',
			( $elm, options ) => {
				var address = this.get( 'address' );

				if ( ! options.format ) {
					return address;
				}

				var parts = address.split( ', ' );

				if ( parts.length < 2 ) {
					return address;
				}

				switch ( options.format ) {
					case 'short':
						return [ parts[0], parts[1] ].join( ', ' );

					case 'long':
						return parts.join( ', ' );
				}
			}
		];
	},

	bindTime: function() {
		return [
			'change:time',
			() => {
				if ( ! this.get( 'isEvent' ) ) {
					return '';
				}

				var time = this.get( 'time' );

				return 'Start: ' + moment( time, 'HH:mm:ss' ).format( 'h:mma' );
			},
		];
	},

	bindDistance: function() {
		return [
			'change:stops change:distance',
			() => {
				var meters = this.get( 'distance' );

				if ( meters < 1000 ) {
					return Math.round( meters ) + 'm';
				}

				return ( meters / 1000 ).toFixed( 1 ).replace( '.0', '' ) + 'km';
			},
		];
	},

	bindMaplink: function() {
		return [
			'change:lat change:lng',
			$elm => {
				var coords = this.getPosition( 'as string' );

				$elm.attr( 'href', 'https://www.google.com/maps/search/?api=1&query=' + coords );
			},
		];
	},

	geocode: function() {
		// Skip if ID is empty
		if ( ! this.id ) {
			return;
		}

		// Skip if ID is not a string
		if ( typeof this.id !== 'string' ) {
			return;
		}

		// Skip if ID is numeric
		if ( this.id.match( /^\d+$/ ) ) {
			return;
		}

		getPlace( this.id, result => {
			if ( result && result.geometry ) {
				this.set( result.geometry.location );
			}
		} );
	},
} );
